import "@esri/calcite-components/dist/components/calcite-loader";
import {FaFileAlt} from 'react-icons/fa'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { setNavLoc } from '../../features/navLocSlice'
import './reportNotice.scss'
import { CalciteLoader } from '@esri/calcite-components-react'

const ReportNotice = ({ title, path, loading }) => {

    const navigate = useNavigate()
    const dispatch = useDispatch()
    const county = useSelector(state => state.county)
    const muni = useSelector(state => state.muni)

    const handleClick = () => {
        dispatch(setNavLoc(path))
        
        // Construct URL with location parameters
        let url = `/${path}`
        if (muni) {
            url = `/${path}/muni/${muni.MUN_CODE}`
        } else if (county) {
            url = `/${path}/county/${county.GEOID}`
        }
        
        navigate(url)   
    }
    
    return (
        <div
            className='report-notice'
            onClick={handleClick}
        ><div style={{display: 'flex', alignItems: 'center', width: '50px', height: '50px'}}>
            {loading ? <CalciteLoader></CalciteLoader> : 
            <FaFileAlt color='#2f85ae' size='4.8rem' title='file icon' />}
        </div>
            <span>{title}</span>
        </div>
    )
}

export default ReportNotice